import { render, staticRenderFns } from "./dealer-transaction.vue?vue&type=template&id=82a4d710&scoped=true&"
import script from "./dealer-transaction.vue?vue&type=script&lang=js&"
export * from "./dealer-transaction.vue?vue&type=script&lang=js&"
import style0 from "./dealer-transaction.vue?vue&type=style&index=0&id=82a4d710&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a4d710",
  null
  
)

export default component.exports